<template>
  <AttachmentsList
    attachable-type="task"
    :attachable-id="taskId"
    :project-id="projectId"
    :current-user-id="currentUserId"
    :author-id="taskAuthorId"
    :expanded="expanded"
    @uploaded="handleUploaded"
    @deleted="handleDeleted"
    @count-changed="handleCountChanged"
  />
</template>

<script setup>
import AttachmentsList from '~/components/common/AttachmentsList.vue'

const props = defineProps({
  taskId: {
    type: [String, Number],
    required: true,
  },
  projectId: {
    type: [String, Number],
    required: true,
  },
  currentUserId: {
    type: [String, Number],
    required: true,
  },
  taskAuthorId: {
    type: [String, Number],
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['uploaded', 'deleted', 'count-changed'])

const handleUploaded = data => {
  emit('uploaded', data)
}

const handleDeleted = id => {
  emit('deleted', id)
}

const handleCountChanged = count => {
  emit('count-changed', count)
}
</script>
